import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const DOMLocker: React.FC<React.PropsWithChildren<SvgIconProps>> = (props) => (
  <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14 1C15.1 1 16 1.9 16 3V10H18.5C20.433 10 22 11.567 22 13.5C22 15.433 20.433 17 18.5 17H16V21C16 22.1 15.1 23 14 23H7C5.9 23 5 22.1 5 21V3C5 1.9 5.9 1 7 1H14ZM7 21H14V14H7V21ZM16 15H18.5C19.3284 15 20 14.3284 20 13.5C20 12.6716 19.3284 12 18.5 12H16V15ZM7 12H14V3H7V12Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.5 20C9.11929 20 8 18.8807 8 17.5C8 16.1193 9.11929 15 10.5 15C11.8807 15 13 16.1193 13 17.5C13 18.8807 11.8807 20 10.5 20ZM10.5 16.5C11.0523 16.5 11.5 16.9477 11.5 17.5C11.5 18.0523 11.0523 18.5 10.5 18.5C9.94772 18.5 9.5 18.0523 9.5 17.5C9.5 16.9477 9.94772 16.5 10.5 16.5Z"
      fill="currentColor"
    />
    <path
      d="M11.25 4.75C11.25 5.16421 10.9142 5.5 10.5 5.5C10.0858 5.5 9.75 5.16421 9.75 4.75C9.75 4.33579 10.0858 4 10.5 4C10.9142 4 11.25 4.33579 11.25 4.75Z"
      fill="currentColor"
    />
    <path
      d="M11.25 6.75C11.25 7.16421 10.9142 7.5 10.5 7.5C10.0858 7.5 9.75 7.16421 9.75 6.75C9.75 6.33579 10.0858 6 10.5 6C10.9142 6 11.25 6.33579 11.25 6.75Z"
      fill="currentColor"
    />
    <path
      d="M11.25 8.75C11.25 9.16421 10.9142 9.5 10.5 9.5C10.0858 9.5 9.75 9.16421 9.75 8.75C9.75 8.33579 10.0858 8 10.5 8C10.9142 8 11.25 8.33579 11.25 8.75Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default DOMLocker;
